<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { OUTBOUND_ENUM } from "../tabs.config";
import { computed, ref } from "vue";
import VFormDemographic from "@/Shared/Survey/Outbound/VFormDemographic.vue";
import VFormTravel from "@/Shared/Survey/Outbound/VFormTravel.vue";
import VFormExpense from "@/Shared/Survey/Outbound/VFormExpense.vue";
import VFormAirEntryPoint from "@/Shared/Survey/Outbound/VFormAirEntryPoint.vue";
import VFormFeedbacks from "@/Shared/Survey/Outbound/VFormFeedbacks.vue";
import VFormVacation from "@/Shared/Survey/Outbound/VFormVacation.vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
    answers: Object,
    errors: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);
const form = ref(props.answers);

const activeComponent = computed({
    get() {
        const additional = {
            surveyFields: props.surveyFields,
            answers: form.value,
            errors: props.errors,
        };

        switch (props.tab.key) {
            case OUTBOUND_ENUM.FORM_1:
                return {
                    component: VFormDemographic,
                    additional: additional,
                };
            case OUTBOUND_ENUM.FORM_2:
                return {
                    component: VFormTravel,
                    additional: additional,
                };
            case OUTBOUND_ENUM.FORM_3:
                return {
                    component: VFormVacation,
                    additional: additional,
                };
            case OUTBOUND_ENUM.FORM_4:
                return {
                    component: VFormExpense,
                    additional: additional,
                };
            case OUTBOUND_ENUM.FORM_5:
                return {
                    component: VFormAirEntryPoint,
                    additional: additional,
                };
            case OUTBOUND_ENUM.FORM_6:
                return {
                    component: VFormFeedbacks,
                    additional: additional,
                };
        }
    },
});

const handelOnNext = (data) => {
    for (let props in data) {
        form.value[props] = data[props];
    }

    emits("onNext", { ...form.value });
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <h5>{{ tab.title }}</h5>
            <VDevider class="mb-4" />
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    @onNext="handelOnNext"
                    @onPrev="emits('onPrev')"
                />
            </KeepAlive>
        </div>
    </div>
</template>
